<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Centro Visión SL © Copyright {{ today | date:'y'}} </p>
    </div>
  </div>
</div>